import React from 'react';
import Currency from '../Currency';
import IItemProps from './IItemProps';
import {
  BuyerBeforeContent,
  BuyerClosingContent,
  EmptyContent,
  NameContent,
  OtherContent,
  RowNumber,
  SellerBeforeContent,
  SellerClosingContent,
} from './StyledCdItemCells';
import styled from 'styled-components';

export interface ITotalCosts extends IItemProps {
  text: string;
  buyerClosingTotal: number | null;
  buyerBeforeTotal: number | null;
  sellerClosingTotal: number | null;
  sellerBeforeTotal: number | null;
  othersTotal: number | null;
}
const nameCellWidth = '1fr';
const columnWidth = '120px';
const narrowColumnWidth = '60px';
const wideColumnWidth = '180px';
const numberColumnWidth = '30px';

const TotalCostsRow = styled.div<{ showSeller: boolean }>`
  display: grid;
  min-height: 50px;
  grid-template-columns: ${(props) =>
    `${numberColumnWidth} ${nameCellWidth} repeat(${
      props.showSeller ? '5' : '3'
    }, ${columnWidth}) ${narrowColumnWidth} ${wideColumnWidth} ${narrowColumnWidth}`};
  grid-template-areas: ${(props) =>
    `'row-number name buyer-closing buyer-before ${
      props.showSeller ? 'seller-closing seller-before' : ''
    } others empty empty empty'}`};
`;

export class TotalCosts extends React.Component<ITotalCosts> {
  public render() {
    return (
      <TotalCostsRow showSeller={this.props.showSeller}>
        <RowNumber noCounter={true} />
        <NameContent>{this.props.text}</NameContent>
        <BuyerClosingContent>
          <Currency value={this.props.buyerClosingTotal} />
        </BuyerClosingContent>
        <BuyerBeforeContent>
          <Currency value={this.props.buyerBeforeTotal} />
        </BuyerBeforeContent>
        {this.props.showSeller && (
          <SellerClosingContent>
            <Currency value={this.props.sellerClosingTotal} />
          </SellerClosingContent>
        )}
        {this.props.showSeller && (
          <SellerBeforeContent>
            <Currency value={this.props.sellerBeforeTotal} />
          </SellerBeforeContent>
        )}
        <OtherContent>
          <Currency value={this.props.othersTotal} />
        </OtherContent>
        <EmptyContent />
      </TotalCostsRow>
    );
  }
}
